import React, { useState, useEffect } from 'react'
import { getAuthToken, globalDialog, money, scrollToTop } from '../../../Helper'
import { debounce } from 'lodash'

/** ICONS */
import VisibilityIcon from '@material-ui/icons/Visibility'
import WarningIcon from '@material-ui/icons/Warning'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'

/** Components */
import Label from 'Elements/Label'
import Permission from '../../../comps/permission/Permission'
import { globalTableStyle } from 'Configs/table'
import Alert from 'Comps/elements/Alert'
import MUIDataTable from 'mui-datatables'
import KopSurat from 'Elements/KopSurat'
import ContentWrapper from 'Comps/container/ContentWrapper'
import { makeGetParam } from 'Configs/request.js'

/** Stock Opname Redux */
import {
  deleteStockopname,
  setEditStockopname,
  resetStatusStockopname
} from 'Reduxes/inventory/stockopname/stockopnameActions'

import { useDispatch, useSelector } from 'react-redux'
import PrintProvider, { Print } from 'react-easy-print'
import CustomToolbar from '../../../comps/elements/CustomToolbar'
import { TableConfigOnDownload } from '../../../configs/on-download-table'
import { Chip, CircularProgress, Typography } from '@material-ui/core'
import StockOpnameFilter from './StockOpnameFilter'
import { CustomSortColumn } from '../../../utils/SortColumn'

const TableDataSSR = (props) => {
  const classes = globalTableStyle()

  const { error, success } = useSelector((state) => state.stockopnameReducer)

  const { 
    showDetail, 
    showForm,
    indexSetPage,
    indexSetRowsPerPage,
    indexSetFilters,
    indexSetParams,
    initialPage,
    initialRowsPerPage,
    initialFilters,
    initialParams
   } = props

  const dispatch = useDispatch()

  const handleDelete = (id) => {
    globalDialog(async () => {
      await dispatch(deleteStockopname(id))
      scrollToTop()
    })
  }
  const [page, setPage] = useState(initialPage ?? 0)
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage ?? 10)
  const [count, setCount] = useState(0)
  const [data, setData] = useState()
  const [isLoading, setLoading] = useState(false)

  const hasInitialFilters = Object.keys(initialFilters)?.length > 0

  const initialFiltersValue = hasInitialFilters ? initialFilters : {
    branches: [],
    statuses: [],
    results: [],
    date_from: '',
    date_to: ''
  }

  const [filters, setFilters] = useState(initialFiltersValue)

  const [params, setParams] = useState('')

  /** Fetch Stock Opnames */
  useEffect(() => {
    fetchStockOpnames()
  }, [])

  const fetchStockOpnames = () => {
    setLoading(true)

    if (hasInitialFilters && initialParams) {
      loadStockOpnames(page, rowsPerPage, initialParams).then((res) => {
        setData(res.data)
        setLoading(false)
        setCount(res.total)
      })
    } else {
      loadStockOpnames(page).then((res) => {
        setData(res.data)
        setLoading(false)
        setCount(res.total)
      })
    }
  }

  /** Fetch Products
   * @param page integer
   * @param rowsPerPage integer
   * @param params Parameter URL
   */
  const loadStockOpnames = async (page, rowPerPage = 10, params = null) => {
    if (!rowPerPage) rowPerPage = rowsPerPage
    
    return new Promise(async (resolve, reject) => {
      const auth = getAuthToken()
      const headers = {
        Authorization: auth,
        method: 'GET'
      }

      let query = `${process.env.PW_API_URL}/api/stock_opname`

      if (params) {
        query += `?page=${page}&limit=${rowPerPage}${params}`
        const idxQuestionMarkParam = query.indexOf('?')
        query = query
          .split('')
          .map((str, idx) => {
            if (str === '?' && idx > idxQuestionMarkParam) {
              return '&'
            }
            return str
          })
          .join('')
      } else {
        query += `?page=${page}&limit=${rowPerPage}`
      }

      const stockOpnames = await fetch(query, {
        headers
      })
        .then((res) => res.json())
        .catch(({ message }) => resolve({ message }))

      if (stockOpnames) {
        const total = stockOpnames.total
        const data = stockOpnames.data

        resolve({
          data,
          total
        })
      }

      reject()
    })
  }

  const changePage = (page, rowsPerPage, params = null) => {
    setLoading(true)

    loadStockOpnames(page, rowsPerPage, params).then((res) => {
      setTimeout(() => {
        setLoading(false)
        setPage(page)
        setData(res.data)
        setCount(res.total)
        setRowsPerPage(rowsPerPage)
        indexSetPage(page)
        indexSetRowsPerPage(rowsPerPage)
      })
    })
  }

  const columns = [
    {
      name: 'id',
      options: {
        display: false,
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'no',
      label: 'No.',
      options: {
        filter: false,
        customBodyRender: (value, tableMeta) => {
          const tableState = tableMeta.tableState
          const { page, rowsPerPage } = tableState
          if (page >= 1) {
            const result = tableMeta.rowIndex + 1 + page * rowsPerPage
            return result
          }
          return tableMeta.rowIndex + 1
        }
      }
    },
    {
      name: 'code',
      label: 'Code',
      options: {
        filter: false
      }
    },
    {
      name: 'date',
      label: 'date',
      options: {
        filter: false
      }
    },
    {
      name: 'branch_name',
      label: 'Branch',
      options: {
        filter: false
      }
    },
    {
      name: 'result',
      label: 'Result',
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const label = value === 'match' ? value : 'not match'
          if (tableMeta.rowData[6] !== 'draft') {
            return (
              <Label
                text={label}
                type={value === 'match' ? 'success' : 'danger'}
              />
            )
          }
        }
      }
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: false,
        customBodyRender: (value) => {
          let type = ''
          if (value === 'draft') {
            type = 'grey'
          } else if (value === 'checked') {
            type = 'success'
          } else {
            type = 'primary'
          }

          return <Label text={value} type={type} />
        }
      }
    },
    {
      name: 'created_by_contact_name',
      label: 'Created By'
    },
    {
      name: 'id',
      label: 'Actions',
      options: {
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            right: 0,
            zIndex: 51
          }
        }),
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            right: '0',
            background: 'white',
            zIndex: 51
          }
        }),
        filter: false,
        print: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log('val', value)
          const attrShow = {
            className: 'row-action',
            onClick: () => showDetail(value)
          }
          const attrEdit = {
            className: 'row-action',
            onClick: () => {
              dispatch(setEditStockopname(value))
              showForm('Edit')
              scrollToTop()
            }
          }
          const attrDelete = {
            className: 'row-action',
            onClick: () => handleDelete([value])
          }

          return (
            <>
              <VisibilityIcon {...attrShow} />
              {tableMeta.rowData[5] === 'selisih' &&
                tableMeta.rowData[6] === 'open' && (
                  <WarningIcon className="row-action red" />
                )}
              {tableMeta.rowData[6] === 'draft' && (
                <Permission
                  component={<EditIcon {...attrEdit} />}
                  subMenu="stock_opname"
                  type="update"
                />
              )}
              {tableMeta.rowData[6] === 'draft' && (
                <Permission
                  component={<DeleteIcon {...attrDelete} />}
                  subMenu="stock_opname"
                  type="delete"
                />
              )}
            </>
          )
        }
      }
    }
  ]

  const handleSearch = debounce((keyword, props) => {
    setLoading(true)
    const params = makeGetParam({ q: keyword })
    loadStockOpnames(page, rowsPerPage, params).then((res) => {
      setData(res.data)
      setCount(res.total)
      setLoading(false)
    })
  }, 1000)

  const handleFilterSubmit = ({
    branches,
    date_from,
    date_to,
    statuses,
    results
  }) => {
    setLoading(true)
    let params = ''

    setFilters({
      branches,
      date_from,
      date_to,
      statuses,
      results
    })

    indexSetFilters({
      branches,
      date_from,
      date_to,
      statuses,
      results
    })

    if (branches?.length) {
      branches = serializeSelectValue(branches)
      params += makeGetParam({ branch_ids: branches })
    }

    if (statuses?.length) {
      statuses = serializeSelectValue(statuses)
      params += makeGetParam({ statuses })
    }

    if (date_from && date_to) {
      params += makeGetParam({ date_from, date_to })
    }

    if (results?.length) {
      results = serializeSelectValue(results)
      params += makeGetParam({ results })
    }

    setParams(params)
    indexSetParams(params)

    setTimeout(() => {
      loadStockOpnames(0, 10, params).then((res) => {
        setData(res.data)
        setCount(res.total)
        setLoading(false)
        indexSetPage(0)
        indexSetRowsPerPage(10)
      })
    })
  }

  const serializeSelectValue = (data) => {
    return data.map((data) => data.value)
  }

  const onDeleteChip = (title) => {
    switch (title) {
      case 'Branch':
        filters.branches = []
        setFilters(filters)
        break
      case 'Status':
        filters.statuses = []
        setFilters(filters)
        break
      case 'Date':
        filters.date_from = ''
        filters.date_to = ''
        setFilters(filters)
        break
      case 'Result':
        filters.results = []
        setFilters(filters)
        break
      default:
    }

    handleFilterSubmit(filters)
  }

  const RenderChipFilter = () => {
    let keyProperty = []

    if (filters.branches?.length) {
      keyProperty.push({
        title: 'Branch',
        lists: filters.branches.map(({ label }) => label)
      })
    }

    if (filters.statuses?.length) {
      keyProperty.push({
        title: 'Status',
        lists: filters.statuses.map(({ label }) => label)
      })
    }

    if (filters.results?.length) {
      keyProperty.push({
        title: 'Result',
        lists: filters.results.map(({ label }) => label)
      })
    }

    if (filters.date_from && filters.date_to) {
      keyProperty.push({
        title: 'Date',
        lists: `${filters.date_from} - ${filters.date_to}`
      })
    }

    return keyProperty.map(({ title, lists }) => (
      <>
        <Chip
          variant="outlined"
          color="secondary"
          label={`${title}: ${lists}`}
          key={title}
          onDelete={() => onDeleteChip(title)}
        />
      </>
    ))
  }

  const handleDeleteBatch = (ids) => {
    const triggerDelete = async (ids) => {
      await Promise.all(
        ids.map(async (id) => {
          await dispatch(deleteStockopname(id))
        })
      )
    }

    triggerDelete(ids)
    scrollToTop()
    setLoading(false)
    fetchStockOpnames()
  }

  const options = {
    // responsive: 'stacked' /* scroll */,
    responsive: false /* scroll */,
    rowsPerPage: rowsPerPage || 10,
    colIdPosition: 0,
    filename: 'Stock_Opname_Data',
    rowsPerPageOptions: [10, 25, 50],
    filter: true,
    serverSide: true,
    sort: true,
    print: false,
    count: count || 10,
    confirmFilters: true,
    page: page,
    customFilter: true,
    customFilterDialogFooter: () => (
      <StockOpnameFilter
        handleFilterSubmit={handleFilterSubmit}
        isLoading={isLoading}
        stateFilters={filters}
      />
    ),
    customToolbar: () => <CustomToolbar showPrint={true} />,
    onSearchChange: (keyword) => {
      handleSearch(keyword)
    },
    onDownload: (buildHead, buildBody, columns, values) =>
      TableConfigOnDownload(
        'Stock_Opname_Data',
        buildHead,
        buildBody,
        columns,
        values
      ),
    onTableChange: (action, tableState) => {
      if (action === 'changePage' || action === 'changeRowsPerPage') {
        changePage(tableState.page, tableState.rowsPerPage, params)
      }
    },
    onRowsDelete: (e) => {
      const ids = e.data.map(({ index }) => index)

      const opnameIds = data
        .filter((val, idx) => ids.includes(idx))
        ?.map((data) => data.id)

      setLoading(true)
      handleDeleteBatch(opnameIds)
      fetchStockOpnames()
    },
    onColumnSortChange: (changedColumn, direction) => {
      setLoading(true)

      const sortered = CustomSortColumn(changedColumn, direction, data)

      if (sortered.length) {
        setData(sortered)

        setTimeout(() => {
          setLoading(false)
        }, 300)
      }
    },
    //ngeset loading dalam table nya gini aja mif.
    textLabels: {
      body: {
        noMatch: isLoading ?
          <Typography variant="h6">
            {(
              <CircularProgress
                size={24}
                style={{ marginLeft: 15, position: 'relative', top: 4 }}
              />
            )}
          </Typography> : 'Sorry, there is no matching data to display'
      }
    }
  }

  console.log(data)

  return (
    <PrintProvider>
      <Print single name="print-product-table-1">
        <KopSurat />
        <div className="spacer-60"></div>
        <ContentWrapper
          title="Data Stock Opnames"
          subtitle="showing table of all data stock opnames"
          buttons={[
            {
              label: 'Add Stock Opname',
              style: 'OrangeMd',
              icon: 'plus-circle',
              onClick: () => showForm('New'),
              type: 'create',
              subMenu: 'stock_opname'
            }
          ]}
        >
          <>
            {success && (
              <Alert
                hide={() => dispatch(resetStatusStockopname())}
                option={{ type: 'success', message: success }}
              />
            )}
            {error && (
              <Alert
                hide={() => dispatch(resetStatusStockopname())}
                option={{ type: 'error', message: error }}
              />
            )}

            {/* <Typography variant="h6">
              {isLoading && (
                <CircularProgress
                  size={24}
                  style={{ marginLeft: 15, position: 'relative', top: 4 }}
                />
              )}
            </Typography> */}

            {filters && <RenderChipFilter />}
            {
              <MUIDataTable
                data={data}
                columns={columns}
                options={options}
                className={classes.table}
              />
            }
          </>
        </ContentWrapper>
      </Print>
    </PrintProvider>
  )
}

export default TableDataSSR
